// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"943dbc1a","453":"dc579ee0","455":"74e7d4ab","977":"5b19dca4"}[chunkId] + ".chunk.js";
};